import React from 'react';
import { createPortal } from 'react-dom';
import { EstateAssets, EstateProfile, IHTCalculation, ActionPack } from '../../types';
import { ReportBody } from './ReportBody';
import { TrustEstateInclusionNotice } from './TrustEstateInclusionNotice';
import '../evidencePackPrint.css';

interface Props {
    profile: EstateProfile;
    assets: EstateAssets;
    ihtCalc?: IHTCalculation;
    actionPack?: ActionPack;
    probateConfidence?: 'definite' | 'likely' | 'uncertain' | null;
}

export const ProbateReport: React.FC<Props> = ({
    profile, assets, ihtCalc, actionPack, probateConfidence,
}) => {
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => { setMounted(true); }, []);
    if (!mounted) return null;
    if (!ihtCalc || !actionPack) return null;

    return createPortal(
        <div id="probate-report-view" className="hidden print:block report-root bg-white text-[#1A1A1A]">
            <style>{`
                @media print {
                    body { visibility: hidden; }
                    #probate-report-view {
                        visibility: visible;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        display: block !important;
                    }
                    #root > *:not(#probate-report-view-wrapper) { display: none; }
                }
            `}</style>
            <TrustEstateInclusionNotice ihtCalc={ihtCalc} />
            <ReportBody
                profile={profile}
                assets={assets}
                ihtCalc={ihtCalc}
                actionPack={actionPack}
                probateConfidence={probateConfidence}
                printMode
            />
        </div>,
        document.body,
    );
};
